module.exports = __webpack_public_path__ + "static/media/29ADMSPC38.546c992e.jpg";